
import * as React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Api } from "../../lib/Api";
// import { Paypal } from "../../lib/Paypal";

interface IDashboardProps {
    setUrl:any
}

interface IMenu{
    icon     : string
    iconAlign: 'left'|'top'
    url      : string
    title    : string
}

interface IDashboardState {

}

export default class Dashboard extends React.Component<IDashboardProps, IDashboardState>{

    private menus:Array<IMenu>;

  	constructor(props:IDashboardProps){
        super(props);
        this.menus = [
            {
                icon     : 'img/menu_icons/profile.png',
                iconAlign: 'top',
                title    : 'Restaurant types',
                url      : '/admin/restaurant-types/'
            },
            {
                icon     : 'img/menu_icons/profile.png',
                iconAlign: 'top',
                title    : 'Types',
                url      : '/admin/types/'
            },

            {
                icon     : 'img/menu_icons/profile.png',
                iconAlign: 'top',
                title    : 'Restaurants',
                url      : '/admin/restaurants/'
            },
            {
                icon     : 'img/menu_icons/users.png',
                iconAlign: 'top',
                title    : 'Users',
                url      : '/admin/users/'
            },
            {
                icon     : 'img/menu_icons/profile.png',
                iconAlign: 'top',
                title    : 'Deliveries',
                url      : '/admin/deliveries/'
            }
        ];

        if (Api.OTPSimpleModulePermissionEnabled() ) {
            this.menus.push({
                icon: 'img/menu_icons/profile.png',
                iconAlign: 'top',
                title: 'OTP Simple modul',
                url: '/admin/otp_simple/'
            });
        }
    }

    private clickHandler(evt, url:string): void {
        evt.preventDefault();
        this.props.setUrl(url);
    }


    render() {
        return (
            <>
               <Header setUrl={this.props.setUrl}></Header>

               <div className="content_section container">
                    <section className="dashboard_menu">
                        <div className="row">
                            { this.menus.map((menu, index) =>{
                                let className = 'col-6 text-center box_align_'+menu.iconAlign;
                                return <div className={className} key={index}>
                                    <a onClick={ (e) => { this.clickHandler(e, menu.url); } }>
                                        <span>
                                            <img src={menu.icon} alt="" />
                                            { menu.iconAlign === 'top'?<div>
                                                { menu.title }
                                            </div>:menu.title }
                                        </span>
                                    </a>
                                </div>
                            })}
                        </div>
                    </section>
               </div>
               <Footer setUrl={this.props.setUrl}></Footer>
			</>
        );
    }
}
